export const LOADING_NOTIFICATION = "LOADING_NOTIFICATION";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const LOADING_PUSHNOTIFICATION = "LOADING_PUSHNOTIFICATION";
export const GET_PUSHNOTIFICATION = "GET_PUSHNOTIFICATION";
export const PUT_PUSHNOTIFICATION = "PUT_PUSHNOTIFICATION";